<template>
  <div>

    <div class="h-20 flex items-center bg-gray-100 rounded-t-lg border-b-2 border-gray-200 justify-between">
      <h1 class="text-xl font-semibold uppercase tracking-wider ml-6 text-blue-800">Search Teams</h1>
      <h1 class="text-xl font-semibold uppercase tracking-wider mr-6 text-blue-800">DPC.Tools</h1>
    </div>

    <div class="h-32 bg-white">
      <div class="flex p-10">
        <div class="w-1/3 pr-10 hidden md:block">
          <div class="font-bold text-blue-800">Team Name</div>
          <p class="mt-4 text-sm text-gray-700">For Example: Secret</p>
        </div>
        <div class="w-full md:w-2/3">
          <div class="mb-4">
            <input class="w-full rounded bg-gray-200 p-3 focus:outline-none focus:shadow-outline" type="text" v-model="search" placeholder="Search for team..." @keyup.enter="searchTeams(search)">
          </div>
        </div>
      </div>
    </div>

    <div class="h-20 flex items-center justify-between bg-gray-100 rounded-b-lg border-t-2 border-gray-200">
      <button class="btn-red ml-6 focus:outline-none" @click="reset()">Reset</button>
      <button class="btn-blue mr-6 focus:outline-none" @click="searchTeams(search)">Search</button>
    </div>

    <!-- Team Table -->
    <div class="mt-10 bg-white rounded-lg overflow-hidden">
      <table class="w-full border-collapse table-fixed">
        <thead>
          <tr class="bg-gray-300 text-gray-600 uppercase text-xs h-10 border-b-2 border-gray-400 tracking-wide">
            <th>Team Name</th>
            <th>Team ID</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="team in teamData" :key="team.team_id" class="border-b-2 border-gray-200 text-center hover:bg-gray-100">
            <td class="py-4">{{ team.team_name }}</td>
            <td class="py-4">{{ team.team_id }}</td>
            <td class="py-4">
              <button class="btn-sm mx-auto focus:outline-none" @click="searchPlayers(team.team_id)">View Players</button>
            </td>
          </tr>
          <tr class="border-b-2 border-gray-200 text-center hover:bg-gray-100" v-if="!teamData[0]">
            <td v-if="!loadingTeams" class="py-4" colspan="3">No Teams Found</td>
            <td v-if="loadingTeams" class="py-4" colspan="3">
              <img class="w-10 h-10 mx-auto" src="https://cdnjs.cloudflare.com/ajax/libs/semantic-ui/0.16.1/images/loader-large.gif">
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Player Table -->
    <div class="mt-10 bg-white rounded-lg overflow-hidden">
      <table class="w-full border-collapse table-fixed">
        <thead>
          <tr class="bg-gray-300 text-gray-600 uppercase text-xs h-10 border-b-2 border-gray-400 tracking-wide">
            <th>Full Name</th>
            <th>Nickname</th>
            <th>Registration Time</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(player,index) in playerData" :key="index" class="border-b-2 border-gray-200 text-center hover:bg-gray-100">
            <td class="py-4">{{ player.full_name }}</td>
            <td class="py-4">{{ player.nickname }}</td>
            <td class="py-4">{{ player.date_string }}</td>
          </tr>
          <tr class="border-b-2 border-gray-200 text-center hover:bg-gray-100" v-if="!playerData[0]">
            <td v-if="!loadingPlayers" class="py-4" colspan="3">No Players Found</td>
            <td v-if="loadingPlayers" class="py-4" colspan="3">
              <img class="w-10 h-10 mx-auto" src="https://cdnjs.cloudflare.com/ajax/libs/semantic-ui/0.16.1/images/loader-large.gif">
            </td>
          </tr>
        </tbody>
      </table>
    </div>

  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'TeamSearch',
  data () {
      return {
        search: '',
        teamData: [],
        playerData: [],
        loadingTeams: false,
        loadingPlayers: false
      }
  },
  methods: {
    reset: function() {
      this.search = '';
      this.teamData = [];
      this.playerData = [];
      this.loadingTeams = false;
      this.loadingPlayers = false;
    },
    searchTeams: function(team_name) {
      const name = team_name.replace(/ /g,"+");
      this.loadingTeams = true;
      this.playerData = [];
      this.teamData = [];
      axios
        .get('/api/majorsregistration/teamlist?substr=' + name)
        .then(response => {
          this.teamData = response.data
          this.loadingTeams = false
        })
        .catch(error => {
          console.log(error)
        })
    },
    searchPlayers: function(team_id) {
      this.loadingPlayers = true;
      this.playerData = [];
      // this.teamData = [];
      axios
        .get('/api/majorsregistration/teammembers?team_id=' + team_id)
        .then(response => {
          this.playerData = response.data
          this.loadingPlayers = false
        })
        .catch(error => {
          console.log(error)
        })
    }
  }
}
</script>